import React from 'react';
import './App.css';

function App() {
  const siteName = 'www Joes Jeans';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
